/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface ListIds { 
    /**
     * The IDs of the rows the list shows
     */
    ids: Array<number>;
}
export const ListIds_ids_Validators: ValidatorFn[] =
    [  Validators.required, ];


